var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarzipan = function SvgMarzipan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#marzipan_svg__a)",
    d: "M50.552 154.854c4.169 15.017 61.785 39.087 77.553 38.118s89.46-54.915 90.425-59.115 6.436-29.4-2.9-41.348-55.993-15.182-62.107-15.505-86.563 19.7-92.355 25.519-16.086 32.626-10.616 52.331"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "marzipan_svg__a",
    x1: 48.999,
    x2: 220.999,
    y1: 135,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#238DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#3C9AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#64AED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#9BCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#E0EFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgMarzipan;